import { FilterFieldCapability } from './baseFilterTypes'

// Operators the Kysely executor runs, per field kind — the single source of truth: the scalar/relation
// builders execute exactly these, and the FE keeps its offered operators within them (operator-subset
// guard) so v2 never silently drops one. FE-safe: string data only, no Kysely/DB imports.
export const SCALAR_TYPE_OPERATORS = {
  string: ['equals', 'doesNotEqual', 'contains', 'doesNotContain', 'startsWith', 'endsWith', 'isEmpty', 'isNotEmpty', 'isAnyOf'],
  boolean: ['equals', 'doesNotEqual', 'is', 'isEmpty', 'isNotEmpty'],
  number: ['=', '!=', '>', '<', '>=', '<=', 'isEmpty', 'isNotEmpty'],
  date: ['is', 'not', 'before', 'after', 'onOrBefore', 'onOrAfter', 'isEmpty', 'isNotEmpty'],
  timestamp: ['is', 'not', 'before', 'after', 'onOrBefore', 'onOrAfter', 'isEmpty', 'isNotEmpty'],
  uuid: ['equals', 'doesNotEqual', 'isAnyOf', 'isEmpty', 'isNotEmpty'],
  enum: ['equals', 'doesNotEqual', 'isAnyOf', 'isEmpty', 'isNotEmpty'],
  json: ['equals', 'doesNotEqual', 'isEmpty', 'isNotEmpty'],
} as const satisfies Record<NonNullable<FilterFieldCapability['scalarType']>, readonly string[]>

export const RELATION_OPERATORS = [
  'equals',
  'doesNotEqual',
  'contains',
  'doesNotContain',
  'startsWith',
  'endsWith',
  'isAnyOf',
  'isEmpty',
  'isNotEmpty',
] as const

// createdBy/assignees handlers ILIKE a user-search blob operator-agnostically (always contains, per
// legacy `applyUserSearchableStringOp`), so contains is the only operator they honestly serve.
export const COMPUTED_OPERATORS = ['contains'] as const

export const getKyselySupportedOperators = (capability: FilterFieldCapability): readonly string[] => {
  switch (capability.type) {
    case 'scalar':
      return SCALAR_TYPE_OPERATORS[capability.scalarType ?? 'string']
    case 'relation':
      return RELATION_OPERATORS
    case 'computed':
      return COMPUTED_OPERATORS
    case 'custom':
      return []
    default: {
      // FE-safe file, so we can't use the backend `assertNever` (it imports the lambda logger); an
      // inline never-check turns a future capability type into a compile error at this exact spot.
      const exhaustive: never = capability.type
      return exhaustive
    }
  }
}
